import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ashtavinayakdarshancabpackage() {



const cardData = {
  keyword: "Ashtavinayak Darshan Cab Package",
  heading: "Lotus Cab: Ashtavinayak Darshan Cab Package",

  headingDescription:
    "Lotus Cab offers a well-planned Ashtavinayak Darshan Cab Package for devotees seeking a peaceful and comfortable spiritual journey. The Ashtavinayak Yatra covers eight sacred Lord Ganesha temples across Maharashtra and is one of the most important pilgrimage circuits near Pune. Our experienced drivers are familiar with temple routes, darshan timings, and road conditions to ensure smooth travel. We provide AC sedans and spacious SUVs suitable for families and senior citizens. Transparent package pricing with flexible same-day or multi-day options is available. With punctual pickup from Pune and 24/7 booking support, we ensure a safe and spiritually fulfilling journey.",

  top: "Eight Sacred Ashtavinayak Temples Covered in the Yatra",

  topPlaces: [
    {
      title: "Mayureshwar Temple – Morgaon",
      description:
        "Mayureshwar Temple at Morgaon is considered the starting point of the Ashtavinayak Yatra. It is dedicated to Lord Ganesha who defeated the demon Sindhu here. The temple has beautiful stone architecture and spiritual significance. Devotees begin and end the yatra here as per tradition. The peaceful surroundings enhance devotional experience. Comfortable cab travel ensures timely darshan."
    },
    {
      title: "Siddhivinayak Temple – Siddhatek",
      description:
        "Siddhivinayak Temple is located on the banks of Bhima River. It is believed to fulfill wishes and remove obstacles. Devotees perform pradakshina around the hill for blessings. The temple’s serene environment attracts pilgrims year-round. It is an important stop in the Ashtavinayak circuit. Safe cab service makes the journey convenient."
    },
    {
      title: "Ballaleshwar Temple – Pali",
      description:
        "Ballaleshwar Temple is unique as it is named after a devotee, Ballal. It is one of the most revered Ganpati temples in Maharashtra. The temple architecture reflects traditional design. Devotees visit for spiritual blessings and peace. It is a significant part of the Ashtavinayak route. Comfortable SUV travel ensures smooth darshan."
    },
    {
      title: "Varadvinayak Temple – Mahad",
      description:
        "Varadvinayak Temple is known for granting wishes and prosperity. The temple allows devotees to enter the sanctum and perform prayers. It holds great mythological importance. Pilgrims include it as a mandatory stop in the yatra. The calm village surroundings add spiritual value. Reliable cab travel ensures hassle-free visit."
    },
    {
      title: "Chintamani Temple – Theur",
      description:
        "Chintamani Temple at Theur is associated with Lord Ganesha relieving worries. It is located near Pune and easily accessible. The temple has beautiful architecture and a peaceful setting. Devotees seek blessings for peace of mind. It is often visited first or last in the route. Comfortable cab travel enhances pilgrimage experience."
    },
    {
      title: "Girijatmaj Temple – Lenyadri",
      description:
        "Girijatmaj Temple is situated inside a cave on a hill at Lenyadri. Devotees climb steps to reach the temple. It is the only Ashtavinayak temple located in a cave. The scenic view adds to spiritual experience. Senior citizens require safe travel planning. SUV cab service makes access convenient."
    },
    {
      title: "Vighnahar Temple – Ozar",
      description:
        "Vighnahar Temple is dedicated to Lord Ganesha who removes obstacles. It is beautifully maintained and spiritually vibrant. Devotees gather here during festivals. The temple structure is architecturally impressive. It is a peaceful stop in the pilgrimage circuit. Reliable cab service ensures timely darshan."
    },
    {
      title: "Mahaganapati Temple – Ranjangaon",
      description:
        "Mahaganapati Temple at Ranjangaon is one of the most powerful Ashtavinayak temples. It is associated with Lord Shiva’s worship of Ganesha. The temple attracts large numbers of devotees. It is conveniently located near Pune. Spiritual significance makes it an important stop. Comfortable cab journey ensures safe completion of yatra."
    }
  ],

  services: [
    {
      name: "Pune to Ashtavinayak Cab",
      description:
        "Complete Ashtavinayak Darshan from Pune with experienced drivers. Cover all eight temples in a planned route. AC sedan and SUV options available. Safe and comfortable pilgrimage ensured. Transparent package pricing provided. Ideal for family and senior citizen travel."
    },
    {
      name: "Same Day Ashtavinayak Cab",
      description:
        "Same-day darshan package for time-efficient pilgrimage. Early morning departure from Pune supported. Well-planned route minimizes delays. Comfortable vehicles provided. Suitable for small family groups. Affordable pricing ensured."
    },
    {
      name: "Ashtavinayak Yatra Taxi Service",
      description:
        "Dedicated taxi service covering full temple circuit. Experienced drivers familiar with temple schedules. Safe long-distance travel guaranteed. Transparent billing maintained. Flexible itinerary planning available. Stress-free pilgrimage travel."
    },
    {
      name: "Affordable Ashtavinayak Cab Booking",
      description:
        "Budget-friendly cab packages for Ashtavinayak Darshan. Clear fare breakdown shared before booking. No hidden charges applied. Comfortable sedan options available. Suitable for small families. Reliable pilgrimage travel ensured."
    },
    {
      name: "Luxury Cab for Ashtavinayak Yatra",
      description:
        "Premium vehicle options for comfortable pilgrimage. Plush seating for long-distance travel. Suitable for senior citizens and VIP guests. Professional chauffeurs provided. Smooth and safe journey ensured. Premium spiritual travel experience."
    },
    {
      name: "SUV Taxi for Ashtavinayak Darshan",
      description:
        "Spacious SUV vehicles ideal for group travel. Extra luggage space available. Safe driving across rural temple routes. Comfortable interiors maintained. Suitable for extended yatra. Reliable transport guaranteed."
    },
    {
      name: "Online Ashtavinayak Cab Booking",
      description:
        "24/7 online booking system available. Quick confirmation provided. Transparent pricing displayed before booking. Flexible scheduling supported. Easy cancellation options. Convenient booking experience ensured."
    },
    {
      name: "Family Trip Ashtavinayak Taxi",
      description:
        "Family-friendly cab packages designed for group comfort. Safe driving ensured for children and seniors. Flexible darshan timing supported. Spacious seating available. Clean and maintained vehicles provided. Peaceful pilgrimage journey guaranteed."
    }
  ],

  tableData: [
    ["Ashtavinayak Darshan Cab Package", "Ashtavinayak Yatra Taxi Service"],
    ["Pune to Ashtavinayak Cab", "Ashtavinayak Tour Package from Pune"],
    ["Same Day Ashtavinayak Cab", "Affordable Ashtavinayak Cab Booking"],
    ["Luxury Cab for Ashtavinayak Yatra", "SUV Taxi for Ashtavinayak Darshan"],
    ["Online Ashtavinayak Cab Booking", "Family Trip Ashtavinayak Taxi"],
    ["Corporate Group Ashtavinayak Cab", ""]
  ],

  whychoose: [
    {
      WhyChooseheading: "Complete 8 Temple Coverage",
      WhyChoosedescription:
        "We cover all eight sacred Ganpati temples in correct sequence. Well-planned route ensures efficient darshan. No temple is missed. Comfortable travel maintained."
    },
    {
      WhyChooseheading: "Experienced Pilgrimage Drivers",
      WhyChoosedescription:
        "Drivers are familiar with temple routes and timings. Safe rural road driving ensured. Professional behavior maintained."
    },
    {
      WhyChooseheading: "Transparent Package Pricing",
      WhyChoosedescription:
        "Complete fare breakdown shared before booking. No hidden charges applied. Transparent billing policy followed."
    },
    {
      WhyChooseheading: "Flexible Same-Day & Multi-Day Options",
      WhyChoosedescription:
        "Same-day darshan supported. Multi-day relaxed yatra planning available. Flexible scheduling provided."
    },
    {
      WhyChooseheading: "Comfortable Sedan & SUV Options",
      WhyChoosedescription:
        "Vehicles suitable for families and seniors. Spacious interiors maintained. AC comfort ensured."
    },
    {
      WhyChooseheading: "24/7 Booking Assistance",
      WhyChoosedescription:
        "Round-the-clock support available. Immediate confirmation provided. Easy coordination ensured."
    },
    {
      WhyChooseheading: "Family & Senior Citizen Friendly",
      WhyChoosedescription:
        "Safe driving prioritized. Comfortable travel breaks included. Peaceful pilgrimage experience ensured."
    },
    {
      WhyChooseheading: "Reliable & Trusted Service",
      WhyChoosedescription:
        "On-time pickup guaranteed. Well-maintained vehicles provided. Stress-free spiritual journey ensured."
    }
  ]
};

const faqData = [
  { question: "How many temples are covered in Ashtavinayak Yatra?", answer: "The yatra covers eight sacred Lord Ganesha temples located in different districts of Maharashtra." },
  { question: "Is same-day Ashtavinayak darshan possible?", answer: "Yes, same-day package is available with early departure from Pune." },
  { question: "Are SUVs recommended for Ashtavinayak trip?", answer: "SUVs are ideal for family groups and senior citizens due to comfort and space." },
  { question: "Is package pricing fixed?", answer: "Yes, transparent package pricing is provided before confirmation." },
  { question: "Do you provide multi-day yatra options?", answer: "Yes, multi-day relaxed pilgrimage packages are available." },
  { question: "Is online booking available?", answer: "Yes, online booking is available 24/7 with quick confirmation." },
  { question: "Are toll charges included?", answer: "Toll charges are clearly explained before booking confirmation." },
  { question: "Is the route pre-planned?", answer: "Yes, the route is planned to cover all temples efficiently." },
  { question: "Do drivers know temple timings?", answer: "Yes, drivers are familiar with darshan timings and local routes." },
  { question: "Is advance booking recommended?", answer: "Advance booking is recommended during festive seasons." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Suresh Patil",
    feedback:
      "Our Ashtavinayak Darshan trip was smooth and spiritually fulfilling. Driver was punctual and familiar with temple routes. Vehicle was comfortable and clean. Transparent pricing impressed us. Highly recommend Lotus Cab.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meera Kulkarni",
    feedback:
      "We booked SUV for family pilgrimage. Travel was safe and well-planned. Covered all eight temples comfortably. No hidden charges. Excellent service quality.",
    rating: 5
  },
  {
    id: 3,
    name: "Mr. Rajiv Sharma",
    feedback:
      "Same-day Ashtavinayak cab package was perfectly managed. Early pickup and efficient route planning. Comfortable journey throughout. Reliable and professional service.",
    rating: 5
  }
];





















































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ashtavinayak Darshan Cab Package",
  "image": "https://lotuscab.com/assets/images/ashtavinayak-darshan-cab-package.jpg", 
  "description": "Lotus Cab offers Ashtavinayak Darshan cab packages from Pune with same day, luxury, SUV, and family trip options. Book affordable and reliable cabs for Ashtavinayak Yatra, corporate groups, and convenient online booking with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "6800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3999",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/ashtavinayak-darshan-cab-package"
  }
};







  return (
    <div>
      

<Helmet>
  <title>Contact: +91 8767592195 | Ashtavinayak Darshan Cab Package | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Ashtavinayak Darshan cab package from Pune with Lotus Cab. Affordable luxury, SUV, same day & family trip options. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Ashtavinayak Darshan Cab Package, Ashtavinayak Yatra Taxi Service, Pune to Ashtavinayak Cab, Ashtavinayak Tour Package from Pune, Same Day Ashtavinayak Cab, Affordable Ashtavinayak Cab Booking, Luxury Cab for Ashtavinayak Yatra, SUV Taxi for Ashtavinayak Darshan, Online Ashtavinayak Cab Booking, Family Trip Ashtavinayak Taxi, Corporate Group Ashtavinayak Cab" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/18.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ashtavinayakdarshancabpackage;